import type { ReactNode } from 'react'

import css from './index.module.css'

interface Props {
    children: ReactNode
    full?: boolean
    label: string
    wideEnd?: boolean
    wideStart?: boolean
}
export const Section = ({ children, full, label, wideEnd, wideStart }: Props) => {
    const classNames = []
    wideStart && classNames.push(css.wideStart)
    wideEnd && classNames.push(css.wideEnd)
    full && classNames.push(css.full)

    return (
        <div className={classNames.join(' ')}>
            <h3>{label}</h3>
            <div>
                {children}
            </div>
        </div>
    )
}
